<script lang="ts">
	import { Icon } from '@repo/commons/components'

	interface Props {
		text: string
		isFilterChip?: boolean
		removable?: boolean
		externalStyle?: string
		customClass?: string
		isSelected?: boolean
		onclick?: ((event: MouseEvent) => void) | null
		onRemove?: ((text: string) => void) | null
	}

	let {
		text,
		isFilterChip = false,
		removable = true,
		externalStyle = '',
		customClass = '',
		isSelected = $bindable(false),
		onclick = null,
		onRemove = null
	}: Props = $props()

	if (!isFilterChip) isSelected = true

	function handleRemove(): void {
		onRemove?.(text)
	}
</script>

<span class="chip {customClass}" style={externalStyle} data-selected={isSelected} {onclick}>
	{#if isSelected && isFilterChip}
		<div class="tick-icon">
			<Icon name="checkmark" size="xs" />
		</div>
	{/if}
	{text ? text.charAt(0).toUpperCase() + text.slice(1).toLowerCase() : ''}
	{#if removable}
		<!-- svelte-ignore a11y_click_events_have_key_events -->
		<!-- svelte-ignore a11y_no_static_element_interactions -->
		<div
			class="remove-button"
			onclick={(e) => {
				e.stopPropagation()
				handleRemove()
			}}
		>
			<Icon name="close" size="xs" />
		</div>
	{/if}
</span>

<style lang="postcss">
	.chip {
		@apply inline-flex items-center rounded-[16px] px-2 py-[1px] text-[14px] m-0 text-[#001626] bg-[#004980];
	}
	/* When not selected, show as grey */
	.chip:not([data-selected='true']) {
		@apply bg-gray-300 text-black;
	}
	/* When selected, show as blue brand color */
	.chip[data-selected='true'] {
		@apply bg-blue-500 text-white;
	}
	.tick-icon {
		@apply mr-1;
	}
	.remove-button {
		@apply m-1 cursor-pointer text-white;
	}
	.remove-button:hover {
		@apply text-red-500;
	}
</style>
